import { useHistory } from 'react-router-dom';
import pharmacy from 'services/pharmacy';

export default () => {
  const history = useHistory();
  const getExemption = async () => {
    try {
      const response = await pharmacy.get(`/patients/exemption`, { headers: { 'api-version': 'v2' } });
      return response.data;
    } catch (e) {
      return {};
    }
  };

  const putExemption = async (payload) => {
    const data = {
      code: payload?.selectedExemption?.option,
      name: payload?.selectedExemption?.text,
      number: payload?.cert?.number,
      expiry_date: payload?.cert?.expiry,
      ni_number: payload?.ni_number,
    };
    try {
      const response = await pharmacy.put(`/patients/exemption`, data);
      history.push('/pharmacy/dashboard/exemption/saved');
      return response.data;
    } catch (e) {
      console.error({ e });
      return 'Error Updating Exemption';
    }
  };

  const deleteExemption = async () => {
    try {
        const response = await pharmacy.delete(`/patients/exemption`);
        history.push('/pharmacy/dashboard/account');
        return response.data;
    } catch(e) {
        return 'Error removing exemption';
    }
  };

  return [getExemption, putExemption, deleteExemption];
};
